/**
 * Parsers
 * Pure parsing functions for various data types
 */

export {parseNumber, parseFloat} from "./number";
export {parseBoolean, parseString} from "./string";
export {parseMapBound, type GeoCoordinate} from "./geo";
export {parseContactPhones, telHref} from "./phone";
